import React from "react";
import { Link } from "react-router-dom";
import {
  FaCrown,
  FaEye,
  FaGavel,
  FaHandshake,
  FaProjectDiagram,
  FaUserCheck,
} from "react-icons/fa";
import useAuthFounderHeroImage from "../../hooks/useAuthFounderHeroImage";
import usePlatformLogo from "../../hooks/usePlatformLogo";

const FOUNDER_FEATURES = [
  {
    icon: FaGavel,
    title: "First Auction Free",
    copy: "List your first auction at no cost.",
  },
  {
    icon: FaUserCheck,
    title: "Priority onboarding",
    copy: "Get priority onboarding and assisted setup.",
  },
  {
    icon: FaEye,
    title: "Early visibility",
    copy: "Get early visibility for your business listings.",
  },
  {
    icon: FaProjectDiagram,
    title: "Founding network access",
    copy: "Access exclusive founding business network opportunities.",
  },
  {
    icon: FaHandshake,
    title: "Early access to trade",
    copy: "Be the first to access exciting trade opportunities.",
  },
];

function FounderHeroBrand() {
  const logoUrl = usePlatformLogo();

  return (
    <Link to="/home" className="login-page__founder-brand" aria-label="Trocanet home">
      <img
        src={logoUrl}
        alt="Trocanet"
        className="login-page__founder-brand-logo"
      />
    </Link>
  );
}

export default function FounderAccessHeroPanel() {
  const heroImageUrl = useAuthFounderHeroImage();

  return (
    <aside className="login-page__hero login-page__hero--founder" aria-label="Founder access overview">
      <div
        className="login-page__hero-bg"
        style={{ backgroundImage: `url(${heroImageUrl})` }}
        aria-hidden
      />
      <div className="login-page__hero-overlay" aria-hidden />

      <div className="login-page__hero-body">
        <div className="login-page__hero-main">
          <div className="login-page__hero-brand">
            <FounderHeroBrand />
          </div>

          <h1 className="login-page__hero-title login-page__hero-title--founder">
            Founder access.
            <span>Early opportunities for trade.</span>
          </h1>
          <p className="login-page__hero-copy login-page__hero-copy--founder">
            Be among the first to unlock high-value opportunities and grow with a trusted trade
            network.
          </p>

          <ul className="login-page__features login-page__features--founder">
            {FOUNDER_FEATURES.map((feature) => {
              const Icon = feature.icon;
              return (
                <li key={feature.title} className="login-page__feature login-page__feature--card">
                  <span className="login-page__feature-icon login-page__feature-icon--founder" aria-hidden>
                    <Icon />
                  </span>
                  <div className="login-page__feature-text">
                    <p className="login-page__feature-title login-page__feature-title--founder">
                      {feature.title}
                    </p>
                    <p className="login-page__feature-copy login-page__feature-copy--founder">
                      {feature.copy}
                    </p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="login-page__hero-banner">
          <span className="login-page__hero-banner-icon" aria-hidden>
            <FaCrown />
          </span>
          <span className="login-page__hero-banner-text">
            <strong>Founder access</strong>
            <span className="login-page__hero-banner-sep" aria-hidden />
            <span className="login-page__hero-banner-tagline">Build. Connect. Grow together.</span>
          </span>
        </div>
      </div>
    </aside>
  );
}
